/**
 * statusColorMap.js
 * Maps building availability percentages to status enum and colors
 */

export const STATUS_ENUM = {
  OK: 'OK',
  WARNING: 'WARNING',
  CRITICAL: 'CRITICAL'
};

export const STATUS_COLORS = {
  [STATUS_ENUM.OK]: {
    hex: '#4CAF50',
    rgb: 'rgb(76, 175, 80)',
    name: 'Green',
    description: 'Healthy (99-100%)'
  },
  [STATUS_ENUM.WARNING]: {
    hex: '#FFC107',
    rgb: 'rgb(255, 193, 7)',
    name: 'Yellow',
    description: 'Degraded (75-98%)'
  },
  [STATUS_ENUM.CRITICAL]: {
    hex: '#F44336',
    rgb: 'rgb(244, 67, 54)',
    name: 'Red',
    description: 'Critical (<75%)'
  }
};

/**
 * Determine status and color based on availability percentage
 * @param {number} availability - Availability percentage (0-100+)
 * @returns {Object} { status, color, label, availability }
 */
export const getStatusByAvailability = (availability) => {
  // Clamp to 0-100 for display
  const displayAvailability = Math.min(100, Math.max(0, availability));
  
  let status;
  if (displayAvailability >= 99) {
    status = STATUS_ENUM.OK;
  } else if (displayAvailability >= 75) {
    status = STATUS_ENUM.WARNING;
  } else {
    status = STATUS_ENUM.CRITICAL;
  }

  return {
    status,
    color: STATUS_COLORS[status],
    label: `${displayAvailability}%`,
    availability: displayAvailability,
    rawAvailability: availability
  };
};

/**
 * Get all status legend items for UI display
 * @returns {Array} Array of legend items with status, color, description
 */
export const getStatusLegend = () => {
  return [
    {
      status: STATUS_ENUM.OK,
      color: STATUS_COLORS[STATUS_ENUM.OK],
      range: '99-100%',
      description: STATUS_COLORS[STATUS_ENUM.OK].description
    },
    {
      status: STATUS_ENUM.WARNING,
      color: STATUS_COLORS[STATUS_ENUM.WARNING],
      range: '75-98%',
      description: STATUS_COLORS[STATUS_ENUM.WARNING].description
    },
    {
      status: STATUS_ENUM.CRITICAL,
      color: STATUS_COLORS[STATUS_ENUM.CRITICAL],
      range: '<75%',
      description: STATUS_COLORS[STATUS_ENUM.CRITICAL].description
    }
  ];
};
